/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import { dateOnlyToQuery } from './DateOnly';
import type {
  AppointmentForTakeoverResponse,
  AppointmentResponse,
  AssignClientToAppointmentRequest,
  AttendanceOverviewRowResponse,
  CreateAppointmentRequest,
  DeleteAppointmentRequest,
  MoveAppointmentRequest,
  MultiDayAttendanceRequest,
  PlanWeeklyAttendanceRequest,
  PlanWeeklySeriesRequest,
  ProblemDetails,
  PurposeType,
  TakeoverHistoryEntryResponse,
  UpdateAppointmentRequest,
  ValidationProblemDetails,
} from '../models/index';
import {
    AppointmentForTakeoverResponseFromJSON,
    AppointmentForTakeoverResponseToJSON,
    AppointmentResponseFromJSON,
    AppointmentResponseToJSON,
    AssignClientToAppointmentRequestFromJSON,
    AssignClientToAppointmentRequestToJSON,
    AttendanceOverviewRowResponseFromJSON,
    AttendanceOverviewRowResponseToJSON,
    CreateAppointmentRequestFromJSON,
    CreateAppointmentRequestToJSON,
    DeleteAppointmentRequestFromJSON,
    DeleteAppointmentRequestToJSON,
    MoveAppointmentRequestFromJSON,
    MoveAppointmentRequestToJSON,
    MultiDayAttendanceRequestFromJSON,
    MultiDayAttendanceRequestToJSON,
    PlanWeeklyAttendanceRequestFromJSON,
    PlanWeeklyAttendanceRequestToJSON,
    PlanWeeklySeriesRequestFromJSON,
    PlanWeeklySeriesRequestToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    PurposeTypeFromJSON,
    PurposeTypeToJSON,
    TakeoverHistoryEntryResponseFromJSON,
    TakeoverHistoryEntryResponseToJSON,
    UpdateAppointmentRequestFromJSON,
    UpdateAppointmentRequestToJSON,
    ValidationProblemDetailsFromJSON,
    ValidationProblemDetailsToJSON,
} from '../models/index';

export interface AssignClientToAppointmentOperationRequest {
    appointmentId: string;
    assignClientToAppointmentRequest: AssignClientToAppointmentRequest;
}

export interface CreateAppointmentOperationRequest {
    createAppointmentRequest: CreateAppointmentRequest;
}

export interface DeleteAppointmentOperationRequest {
    appointmentId: string;
    deleteAppointmentRequest?: DeleteAppointmentRequest | null;
}

export interface GetAppointmentsByDateRequest {
    startDate?: Date;
    endDate?: Date;
    assignedCounselorId?: string;
    purposeType?: PurposeType;
    unassignedOnly?: boolean;
}

export interface GetAppointmentsForTakeoverRequest {
    counselorId?: string;
}

export interface GetAttendanceOverviewRequest {
    weekStart?: Date;
    originTimeZoneId?: string;
}

export interface GetAvailable1bAppointmentsRequest {
    startDate?: Date;
    endDate?: Date;
}

export interface GetFreeAppointmentSlotsRequest {
    purposeKey?: string;
    assignedCounselorId?: string;
}

export interface GetTakeoverHistoryRequest {
    from?: Date;
    till?: Date;
    givenUpByCounselorId?: string;
    takenOverByCounselorId?: string;
}

export interface MarkAppointmentForTakeoverRequest {
    id: string;
}

export interface MoveAppointmentOperationRequest {
    appointmentId: string;
    moveAppointmentRequest: MoveAppointmentRequest;
}

export interface PlanMultiDayAttendanceRequest {
    multiDayAttendanceRequest: MultiDayAttendanceRequest;
}

export interface PlanWeeklyAttendanceBatchRequest {
    planWeeklyAttendanceRequest: Array<PlanWeeklyAttendanceRequest>;
}

export interface PlanWeeklyAttendanceSeriesRequest {
    planWeeklySeriesRequest: PlanWeeklySeriesRequest;
}

export interface ReverseAppointmentTakeoverRequest {
    id: string;
}

export interface TakeOverAppointmentRequest {
    id: string;
}

export interface UnmarkAppointmentFromTakeoverRequest {
    id: string;
}

export interface UpdateAppointmentOperationRequest {
    appointmentId: string;
    updateAppointmentRequest: UpdateAppointmentRequest;
}

/**
 * AppointmentsApi - interface
 * 
 * @export
 * @interface AppointmentsApiInterface
 */
export interface AppointmentsApiInterface {
    /**
     * 
     * @param {string} appointmentId 
     * @param {AssignClientToAppointmentRequest} assignClientToAppointmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApiInterface
     */
    assignClientToAppointmentRaw(requestParameters: AssignClientToAppointmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentResponse>>;

    /**
     */
    assignClientToAppointment(requestParameters: AssignClientToAppointmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentResponse>;

    /**
     * 
     * @param {CreateAppointmentRequest} createAppointmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApiInterface
     */
    createAppointmentRaw(requestParameters: CreateAppointmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentResponse>>;

    /**
     */
    createAppointment(requestParameters: CreateAppointmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentResponse>;

    /**
     * 
     * @param {string} appointmentId 
     * @param {DeleteAppointmentRequest} [deleteAppointmentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApiInterface
     */
    deleteAppointmentRaw(requestParameters: DeleteAppointmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deleteAppointment(requestParameters: DeleteAppointmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {Date} [startDate] 
     * @param {Date} [endDate] 
     * @param {string} [assignedCounselorId] 
     * @param {PurposeType} [purposeType] 
     * @param {boolean} [unassignedOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApiInterface
     */
    getAppointmentsByDateRaw(requestParameters: GetAppointmentsByDateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AppointmentResponse>>>;

    /**
     */
    getAppointmentsByDate(requestParameters: GetAppointmentsByDateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AppointmentResponse>>;

    /**
     * 
     * @param {string} [counselorId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApiInterface
     */
    getAppointmentsForTakeoverRaw(requestParameters: GetAppointmentsForTakeoverRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AppointmentForTakeoverResponse>>>;

    /**
     */
    getAppointmentsForTakeover(requestParameters: GetAppointmentsForTakeoverRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AppointmentForTakeoverResponse>>;

    /**
     * 
     * @param {Date} [weekStart] 
     * @param {string} [originTimeZoneId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApiInterface
     */
    getAttendanceOverviewRaw(requestParameters: GetAttendanceOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AttendanceOverviewRowResponse>>>;

    /**
     */
    getAttendanceOverview(requestParameters: GetAttendanceOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AttendanceOverviewRowResponse>>;

    /**
     * 
     * @param {Date} [startDate] 
     * @param {Date} [endDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApiInterface
     */
    getAvailable1bAppointmentsRaw(requestParameters: GetAvailable1bAppointmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AppointmentResponse>>>;

    /**
     */
    getAvailable1bAppointments(requestParameters: GetAvailable1bAppointmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AppointmentResponse>>;

    /**
     * 
     * @param {string} [purposeKey] 
     * @param {string} [assignedCounselorId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApiInterface
     */
    getFreeAppointmentSlotsRaw(requestParameters: GetFreeAppointmentSlotsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AppointmentResponse>>>;

    /**
     */
    getFreeAppointmentSlots(requestParameters: GetFreeAppointmentSlotsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AppointmentResponse>>;

    /**
     * 
     * @param {Date} [from] 
     * @param {Date} [till] 
     * @param {string} [givenUpByCounselorId] 
     * @param {string} [takenOverByCounselorId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApiInterface
     */
    getTakeoverHistoryRaw(requestParameters: GetTakeoverHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TakeoverHistoryEntryResponse>>>;

    /**
     */
    getTakeoverHistory(requestParameters: GetTakeoverHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TakeoverHistoryEntryResponse>>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApiInterface
     */
    markAppointmentForTakeoverRaw(requestParameters: MarkAppointmentForTakeoverRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentForTakeoverResponse>>;

    /**
     */
    markAppointmentForTakeover(requestParameters: MarkAppointmentForTakeoverRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentForTakeoverResponse>;

    /**
     * 
     * @param {string} appointmentId 
     * @param {MoveAppointmentRequest} moveAppointmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApiInterface
     */
    moveAppointmentRaw(requestParameters: MoveAppointmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentResponse>>;

    /**
     */
    moveAppointment(requestParameters: MoveAppointmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentResponse>;

    /**
     * 
     * @param {MultiDayAttendanceRequest} multiDayAttendanceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApiInterface
     */
    planMultiDayAttendanceRaw(requestParameters: PlanMultiDayAttendanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AppointmentResponse>>>;

    /**
     */
    planMultiDayAttendance(requestParameters: PlanMultiDayAttendanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AppointmentResponse>>;

    /**
     * 
     * @param {Array<PlanWeeklyAttendanceRequest>} planWeeklyAttendanceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApiInterface
     */
    planWeeklyAttendanceBatchRaw(requestParameters: PlanWeeklyAttendanceBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AppointmentResponse>>>;

    /**
     */
    planWeeklyAttendanceBatch(requestParameters: PlanWeeklyAttendanceBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AppointmentResponse>>;

    /**
     * 
     * @param {PlanWeeklySeriesRequest} planWeeklySeriesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApiInterface
     */
    planWeeklyAttendanceSeriesRaw(requestParameters: PlanWeeklyAttendanceSeriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AppointmentResponse>>>;

    /**
     */
    planWeeklyAttendanceSeries(requestParameters: PlanWeeklyAttendanceSeriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AppointmentResponse>>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApiInterface
     */
    reverseAppointmentTakeoverRaw(requestParameters: ReverseAppointmentTakeoverRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    reverseAppointmentTakeover(requestParameters: ReverseAppointmentTakeoverRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApiInterface
     */
    takeOverAppointmentRaw(requestParameters: TakeOverAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentForTakeoverResponse>>;

    /**
     */
    takeOverAppointment(requestParameters: TakeOverAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentForTakeoverResponse>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApiInterface
     */
    unmarkAppointmentFromTakeoverRaw(requestParameters: UnmarkAppointmentFromTakeoverRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    unmarkAppointmentFromTakeover(requestParameters: UnmarkAppointmentFromTakeoverRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} appointmentId 
     * @param {UpdateAppointmentRequest} updateAppointmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentsApiInterface
     */
    updateAppointmentRaw(requestParameters: UpdateAppointmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentResponse>>;

    /**
     */
    updateAppointment(requestParameters: UpdateAppointmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentResponse>;

}

/**
 * 
 */
export class AppointmentsApi extends runtime.BaseAPI implements AppointmentsApiInterface {

    /**
     */
    async assignClientToAppointmentRaw(requestParameters: AssignClientToAppointmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentResponse>> {
        if (requestParameters['appointmentId'] == null) {
            throw new runtime.RequiredError(
                'appointmentId',
                'Required parameter "appointmentId" was null or undefined when calling assignClientToAppointment().'
            );
        }

        if (requestParameters['assignClientToAppointmentRequest'] == null) {
            throw new runtime.RequiredError(
                'assignClientToAppointmentRequest',
                'Required parameter "assignClientToAppointmentRequest" was null or undefined when calling assignClientToAppointment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/appointments/{appointmentId}/assign-client`;
        urlPath = urlPath.replace(`{${"appointmentId"}}`, encodeURIComponent(String(requestParameters['appointmentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: AssignClientToAppointmentRequestToJSON(requestParameters['assignClientToAppointmentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentResponseFromJSON(jsonValue));
    }

    /**
     */
    async assignClientToAppointment(requestParameters: AssignClientToAppointmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentResponse> {
        const response = await this.assignClientToAppointmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createAppointmentRaw(requestParameters: CreateAppointmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentResponse>> {
        if (requestParameters['createAppointmentRequest'] == null) {
            throw new runtime.RequiredError(
                'createAppointmentRequest',
                'Required parameter "createAppointmentRequest" was null or undefined when calling createAppointment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/appointments`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateAppointmentRequestToJSON(requestParameters['createAppointmentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentResponseFromJSON(jsonValue));
    }

    /**
     */
    async createAppointment(requestParameters: CreateAppointmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentResponse> {
        const response = await this.createAppointmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteAppointmentRaw(requestParameters: DeleteAppointmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['appointmentId'] == null) {
            throw new runtime.RequiredError(
                'appointmentId',
                'Required parameter "appointmentId" was null or undefined when calling deleteAppointment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/appointments/{appointmentId}`;
        urlPath = urlPath.replace(`{${"appointmentId"}}`, encodeURIComponent(String(requestParameters['appointmentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteAppointmentRequestToJSON(requestParameters['deleteAppointmentRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteAppointment(requestParameters: DeleteAppointmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAppointmentRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getAppointmentsByDateRaw(requestParameters: GetAppointmentsByDateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AppointmentResponse>>> {
        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = dateOnlyToQuery(requestParameters['startDate'] as Date);
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = dateOnlyToQuery(requestParameters['endDate'] as Date);
        }

        if (requestParameters['assignedCounselorId'] != null) {
            queryParameters['assignedCounselorId'] = requestParameters['assignedCounselorId'];
        }

        if (requestParameters['purposeType'] != null) {
            queryParameters['purposeType'] = requestParameters['purposeType'];
        }

        if (requestParameters['unassignedOnly'] != null) {
            queryParameters['unassignedOnly'] = requestParameters['unassignedOnly'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/appointments`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AppointmentResponseFromJSON));
    }

    /**
     */
    async getAppointmentsByDate(requestParameters: GetAppointmentsByDateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AppointmentResponse>> {
        const response = await this.getAppointmentsByDateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAppointmentsForTakeoverRaw(requestParameters: GetAppointmentsForTakeoverRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AppointmentForTakeoverResponse>>> {
        const queryParameters: any = {};

        if (requestParameters['counselorId'] != null) {
            queryParameters['counselorId'] = requestParameters['counselorId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/appointments/takeovers`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AppointmentForTakeoverResponseFromJSON));
    }

    /**
     */
    async getAppointmentsForTakeover(requestParameters: GetAppointmentsForTakeoverRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AppointmentForTakeoverResponse>> {
        const response = await this.getAppointmentsForTakeoverRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAttendanceOverviewRaw(requestParameters: GetAttendanceOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AttendanceOverviewRowResponse>>> {
        const queryParameters: any = {};

        if (requestParameters['weekStart'] != null) {
            queryParameters['weekStart'] = dateOnlyToQuery(requestParameters['weekStart'] as Date);
        }

        if (requestParameters['originTimeZoneId'] != null) {
            queryParameters['originTimeZoneId'] = requestParameters['originTimeZoneId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/appointments/attendance/overview`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AttendanceOverviewRowResponseFromJSON));
    }

    /**
     */
    async getAttendanceOverview(requestParameters: GetAttendanceOverviewRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AttendanceOverviewRowResponse>> {
        const response = await this.getAttendanceOverviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAvailable1bAppointmentsRaw(requestParameters: GetAvailable1bAppointmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AppointmentResponse>>> {
        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = dateOnlyToQuery(requestParameters['startDate'] as Date);
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = dateOnlyToQuery(requestParameters['endDate'] as Date);
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/appointments/available-1b`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AppointmentResponseFromJSON));
    }

    /**
     */
    async getAvailable1bAppointments(requestParameters: GetAvailable1bAppointmentsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AppointmentResponse>> {
        const response = await this.getAvailable1bAppointmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getFreeAppointmentSlotsRaw(requestParameters: GetFreeAppointmentSlotsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AppointmentResponse>>> {
        const queryParameters: any = {};

        if (requestParameters['purposeKey'] != null) {
            queryParameters['purposeKey'] = requestParameters['purposeKey'];
        }

        if (requestParameters['assignedCounselorId'] != null) {
            queryParameters['assignedCounselorId'] = requestParameters['assignedCounselorId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/appointments/free-slots`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AppointmentResponseFromJSON));
    }

    /**
     */
    async getFreeAppointmentSlots(requestParameters: GetFreeAppointmentSlotsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AppointmentResponse>> {
        const response = await this.getFreeAppointmentSlotsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getTakeoverHistoryRaw(requestParameters: GetTakeoverHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TakeoverHistoryEntryResponse>>> {
        const queryParameters: any = {};

        if (requestParameters['from'] != null) {
            queryParameters['from'] = dateOnlyToQuery(requestParameters['from'] as Date);
        }

        if (requestParameters['till'] != null) {
            queryParameters['till'] = dateOnlyToQuery(requestParameters['till'] as Date);
        }

        if (requestParameters['givenUpByCounselorId'] != null) {
            queryParameters['givenUpByCounselorId'] = requestParameters['givenUpByCounselorId'];
        }

        if (requestParameters['takenOverByCounselorId'] != null) {
            queryParameters['takenOverByCounselorId'] = requestParameters['takenOverByCounselorId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/appointments/takeovers/history`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TakeoverHistoryEntryResponseFromJSON));
    }

    /**
     */
    async getTakeoverHistory(requestParameters: GetTakeoverHistoryRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TakeoverHistoryEntryResponse>> {
        const response = await this.getTakeoverHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async markAppointmentForTakeoverRaw(requestParameters: MarkAppointmentForTakeoverRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentForTakeoverResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling markAppointmentForTakeover().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/appointments/takeovers/{id}/mark`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentForTakeoverResponseFromJSON(jsonValue));
    }

    /**
     */
    async markAppointmentForTakeover(requestParameters: MarkAppointmentForTakeoverRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentForTakeoverResponse> {
        const response = await this.markAppointmentForTakeoverRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async moveAppointmentRaw(requestParameters: MoveAppointmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentResponse>> {
        if (requestParameters['appointmentId'] == null) {
            throw new runtime.RequiredError(
                'appointmentId',
                'Required parameter "appointmentId" was null or undefined when calling moveAppointment().'
            );
        }

        if (requestParameters['moveAppointmentRequest'] == null) {
            throw new runtime.RequiredError(
                'moveAppointmentRequest',
                'Required parameter "moveAppointmentRequest" was null or undefined when calling moveAppointment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/appointments/{appointmentId}/move`;
        urlPath = urlPath.replace(`{${"appointmentId"}}`, encodeURIComponent(String(requestParameters['appointmentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MoveAppointmentRequestToJSON(requestParameters['moveAppointmentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentResponseFromJSON(jsonValue));
    }

    /**
     */
    async moveAppointment(requestParameters: MoveAppointmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentResponse> {
        const response = await this.moveAppointmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async planMultiDayAttendanceRaw(requestParameters: PlanMultiDayAttendanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AppointmentResponse>>> {
        if (requestParameters['multiDayAttendanceRequest'] == null) {
            throw new runtime.RequiredError(
                'multiDayAttendanceRequest',
                'Required parameter "multiDayAttendanceRequest" was null or undefined when calling planMultiDayAttendance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/appointments/attendance/plan-multi-day`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MultiDayAttendanceRequestToJSON(requestParameters['multiDayAttendanceRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AppointmentResponseFromJSON));
    }

    /**
     */
    async planMultiDayAttendance(requestParameters: PlanMultiDayAttendanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AppointmentResponse>> {
        const response = await this.planMultiDayAttendanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async planWeeklyAttendanceBatchRaw(requestParameters: PlanWeeklyAttendanceBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AppointmentResponse>>> {
        if (requestParameters['planWeeklyAttendanceRequest'] == null) {
            throw new runtime.RequiredError(
                'planWeeklyAttendanceRequest',
                'Required parameter "planWeeklyAttendanceRequest" was null or undefined when calling planWeeklyAttendanceBatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/appointments/attendance/plan-weeks`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['planWeeklyAttendanceRequest']!.map(PlanWeeklyAttendanceRequestToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AppointmentResponseFromJSON));
    }

    /**
     */
    async planWeeklyAttendanceBatch(requestParameters: PlanWeeklyAttendanceBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AppointmentResponse>> {
        const response = await this.planWeeklyAttendanceBatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async planWeeklyAttendanceSeriesRaw(requestParameters: PlanWeeklyAttendanceSeriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AppointmentResponse>>> {
        if (requestParameters['planWeeklySeriesRequest'] == null) {
            throw new runtime.RequiredError(
                'planWeeklySeriesRequest',
                'Required parameter "planWeeklySeriesRequest" was null or undefined when calling planWeeklyAttendanceSeries().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/appointments/attendance/plan-series`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PlanWeeklySeriesRequestToJSON(requestParameters['planWeeklySeriesRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AppointmentResponseFromJSON));
    }

    /**
     */
    async planWeeklyAttendanceSeries(requestParameters: PlanWeeklyAttendanceSeriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AppointmentResponse>> {
        const response = await this.planWeeklyAttendanceSeriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async reverseAppointmentTakeoverRaw(requestParameters: ReverseAppointmentTakeoverRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling reverseAppointmentTakeover().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/appointments/takeovers/{id}/take-over`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async reverseAppointmentTakeover(requestParameters: ReverseAppointmentTakeoverRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.reverseAppointmentTakeoverRaw(requestParameters, initOverrides);
    }

    /**
     */
    async takeOverAppointmentRaw(requestParameters: TakeOverAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentForTakeoverResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling takeOverAppointment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/appointments/takeovers/{id}/take-over`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentForTakeoverResponseFromJSON(jsonValue));
    }

    /**
     */
    async takeOverAppointment(requestParameters: TakeOverAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentForTakeoverResponse> {
        const response = await this.takeOverAppointmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async unmarkAppointmentFromTakeoverRaw(requestParameters: UnmarkAppointmentFromTakeoverRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling unmarkAppointmentFromTakeover().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/appointments/takeovers/{id}/mark`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async unmarkAppointmentFromTakeover(requestParameters: UnmarkAppointmentFromTakeoverRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unmarkAppointmentFromTakeoverRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateAppointmentRaw(requestParameters: UpdateAppointmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentResponse>> {
        if (requestParameters['appointmentId'] == null) {
            throw new runtime.RequiredError(
                'appointmentId',
                'Required parameter "appointmentId" was null or undefined when calling updateAppointment().'
            );
        }

        if (requestParameters['updateAppointmentRequest'] == null) {
            throw new runtime.RequiredError(
                'updateAppointmentRequest',
                'Required parameter "updateAppointmentRequest" was null or undefined when calling updateAppointment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/appointments/{appointmentId}`;
        urlPath = urlPath.replace(`{${"appointmentId"}}`, encodeURIComponent(String(requestParameters['appointmentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAppointmentRequestToJSON(requestParameters['updateAppointmentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateAppointment(requestParameters: UpdateAppointmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentResponse> {
        const response = await this.updateAppointmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
